import React from "react";
import { Card, Typography, Row, Col, Space, Divider, Button } from "antd";
import { FileTextOutlined, PlusOutlined } from "@ant-design/icons";
import { COLORS } from "../../utils/constants";

const { Text, Title } = Typography;

interface ImportedOpportunityDisplayProps {
  projectName: string;
  client: string;
  siteAddress?: string;
  region: string;
  tenderId?: string;
  status?: string;
  onCreateNew?: () => void;
}

const ImportedOpportunityDisplay: React.FC<ImportedOpportunityDisplayProps> = ({
  projectName,
  client,
  siteAddress,
  region,
  tenderId,
  status,
  onCreateNew,
}) => {
  const InfoField: React.FC<{
    label: string;
    value: string;
    required?: boolean;
  }> = ({ label, value, required }) => (
    <div style={{ marginBottom: "12px" }}>
      <Text
        className="block"
        style={{
          fontSize: "13px",
          fontWeight: 600,
          color: "#374151",
          marginBottom: "6px",
          display: "block",
        }}
      >
        {label} {required && <span style={{ color: "#ef4444" }}>*</span>}
      </Text>
      <Text
        style={{
          fontSize: "14px",
          color: "#111827",
          display: "block",
        }}
      >
        {value || "-"}
      </Text>
    </div>
  );

  return (
    <Card
      style={{
        borderRadius: "8px",
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
      }}
    >
      <div style={{ marginBottom: "20px" }}>
        <Space align="center" style={{ marginBottom: "8px" }}>
          <FileTextOutlined
            style={{ fontSize: "20px", color: COLORS.primary }}
          />
          <Title level={5} style={{ margin: 0, color: COLORS.primary }}>
            Imported Opportunity Data
          </Title>
        </Space>
        <br />
        <Text type="secondary" style={{ fontSize: "13px" }}>
          The following information was imported from the selected opportunity.
        </Text>
      </div>

      {tenderId && (
        <>
          <div style={{ marginBottom: "16px" }}>
            <Text style={{ fontSize: "13px", color: "#6b7280" }}>
              <strong>Opportunity ID:</strong> {tenderId}
            </Text>
          </div>
          <Divider style={{ margin: "16px 0" }} />
        </>
      )}

      <Row gutter={[24, 24]}>
        {/* Project Name */}
        <Col xs={24} md={12}>
          <InfoField label="Tender Name" value={projectName} required />
        </Col>

        {/* Client Name */}
        <Col xs={24} md={12}>
          <InfoField label="Client Name" value={client} required />
        </Col>

        {/* Site Address */}
        <Col xs={24} md={12}>
          <InfoField label="Site Address" value={siteAddress || ""} />
        </Col>

        {/* Region */}
        <Col xs={24} md={12}>
          <InfoField label="Region" value={region} required />
        </Col>
      </Row>

      {/* {onCreateNew && (
        <>
          <Divider
            style={{ margin: "24px 0", fontSize: "14px", color: "#6b7280" }}
          >
            or
          </Divider>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={onCreateNew}
              size="large"
              style={{
                backgroundColor: COLORS.primary,
                borderColor: COLORS.primary,
              }}
            >
              Create New Tender
            </Button>
          </div>
        </>
      )} */}
    </Card>
  );
};

export default ImportedOpportunityDisplay;
